import { Trans } from '@lingui/react'
import classNames from 'classnames'
import { arrayOf, bool, func, string } from 'prop-types'

import ButtonAsLink from 'views/components/molecules/ButtonAsLink'

import './SearchHistory.scss'

const SearchHistory = props => {
  const {
    searchHistory,
    handleClearHistory,
    handleQueryUpdate,
    fromPreQuerySuggestions,
  } = props

  const handleClick = event => {
    event.stopPropagation()
    event.preventDefault()

    if (handleClearHistory) {
      handleClearHistory()
    }
  }

  const className = classNames('u-text-align--left u-padding', {
    'o-SearchHistory': !fromPreQuerySuggestions,
    'o-SearchHistory--fromPreQuerySuggestions': true,
  })

  return (
    <div className={className}>
      <div className="l-flex">
        <div className="l-flex__primary">
          <strong className="o-SearchHistory__title">
            <Trans id="searchBox.label.lastSearched" />
          </strong>
        </div>
        <div>
          <ButtonAsLink name="searchistory-delete" onClick={handleClick}>
            <span className="u-font-weight--bold u-text-transform--lowercase o-SearchBox__SearchHistory__link">
              <Trans id="general.button.delete" />
            </span>
          </ButtonAsLink>
        </div>
      </div>
      <div className={'u-padding--top'}>
        {searchHistory.length > 0 && (
          <ul className="o-SearchHistory__list a-list-reset a-list-links">
            {searchHistory.map((query, index) => (
              <li
                className="a-link o-SearchHistory__list-item__wrapper"
                key={`searchistory-link-${index}`}
              >
                <ButtonAsLink
                  name={`searchistory-link-${index}`}
                  neutral
                  onClick={() => handleQueryUpdate(query)}
                  left
                  fullWidth
                  className="o-SearchHistory__list-item"
                >
                  {query}
                </ButtonAsLink>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

SearchHistory.propTypes = {
  searchHistory: arrayOf(string),
  handleClearHistory: func,
  handleQueryUpdate: func,
  fromPreQuerySuggestions: bool,
}

SearchHistory.defaultProps = {
  searchHistory: [],
  handleClearHistory: null,
  handleQueryUpdate: null,
  fromPreQuerySuggestions: false,
}

export default SearchHistory
